import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
// import { WebsocketService } from './core/websocket/websocket.service';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from './core/auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet,
        MatIconModule,
        CommonModule
    ],
})
export class AppComponent {
    public displayButtonsParams = false;
    public isLoggedIn: boolean = false;

    /**
     * Constructor
     */
    constructor(
        // websocketService: WebsocketService,
        private authService: AuthService,
        private matDialog: MatDialog,
    ) {
        this.authService.user$.subscribe(user => {
            this.isLoggedIn = !!user;
        });
    }

    displayButtons() {
        this.displayButtonsParams = !this.displayButtonsParams;
    }
}
